import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import { SAVE_SEARCH_LABEL, SAVE_SEARCH_DESCRIPTION } from './ChatArtifactSaveSearch';
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';

export default function ChatArtifactActionsMenu({
  actions = [],
  actionInFlightKey = null,
  onRunAction,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const visibleActions = Array.isArray(actions)
    ? actions.filter((action) => action?.key && action?.label)
    : [];

  if (visibleActions.length === 0) return null;

  const handleClose = () => setAnchorEl(null);

  const handleAction = (action) => {
    const disabled = action.enabled === false || Boolean(actionInFlightKey);
    if (disabled) return;
    handleClose();
    onRunAction?.(action.key);
  };

  return (
    <>
      <IconButton
        aria-label="Open artifact actions"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <AddCommentOutlinedIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {visibleActions.map((action) => {
          const disabled = action.enabled === false || Boolean(actionInFlightKey);
          const isRunning = actionInFlightKey === action.key;
          const reason = action.disabled_reason ||
            (action.key === 'save_to_workspace'
              ? SAVE_SEARCH_DESCRIPTION
              : action.cost_label);
          return (
            <MenuItem
              key={action.key}
              disabled={disabled}
              onClick={() => handleAction(action)}
            >
              <Box component="span" display="block">
                <Box component="span" display="block">
                  {isRunning ? 'Running...' : action.key === 'save_to_workspace' ? SAVE_SEARCH_LABEL : action.label}
                </Box>
                {reason && (
                  <Box
                    component="span"
                    display="block"
                    sx={{ color: 'text.secondary', fontSize: 12, lineHeight: '18px' }}
                  >
                    {reason}
                  </Box>
                )}
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
